import React from "react";
import { useState } from "react";
import './imageConverter.css';
import Header from "../components/Header"
import HeroSection from "../components/HeroSection"
import ConvertSection from "../components/ConvertSection"

function ImageConverter() {

    const [selected, setSelected] = useState("PNG");

    const [convertFrom, setConvertFrom] = useState("PNG");
    const handleFormatChange = (format) => {
        console.log("Selected format:", format);
        setSelected(format);
        // You can call convert function here
    };
    const handleConvertFrom = (format) => {
        console.log("Selected format:", format);
        setConvertFrom(format);
        // You can call convert function here
    };



    return (
        <div>

            <Header/>

            <HeroSection onFormatChange={handleFormatChange} formatType = {selected} setConvertFrom = {handleConvertFrom}/>

            <ConvertSection onFormatChange={handleFormatChange} foramtType = {selected}  convertFrom = {convertFrom}/>

        </div>
    );
}

export default ImageConverter;